import type { TagVariant } from '../components/tag'

export const getTextVariantColor = (variant: TagVariant) => {
  switch (variant) {
    case 'success':
      return 'success'

    case 'warning':
      return 'warning'

    case 'error':
      return 'error'

    case 'highlight':
      return 'textHighlight'

    case 'default':
    default:
      return 'textTertiary'
  }
}
